import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs';
import { getCustomerConfigState } from '../../../../redux/reducers';

@Component({
  standalone: false,
  selector: 'app-avc-invoices',
  templateUrl: './avc-invoices.component.html',
  styleUrls: ['./avc-invoices.component.scss']
})
export class AvcInvoicesComponent implements OnInit {
  readonly eBillingPortalUrl = 'https://ebillingcentre.amadeus.com/sfiler/Login.action';
  readonly migrationMessage = $localize`:@@amadeus-direct.avc-invoices.migration-message:Your invoices have migrated to a new platform. Click here to get redirected:`;
  readonly eBillingPortalLabel = $localize`:@@amadeus-direct.avc-invoices.e-billing-portal:E-billing portal`;
  viewAVCInvoices = false;

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.select(getCustomerConfigState).pipe(
      filter(config => !!config.customerConfig),
      take(1)
    ).subscribe(config => {
      this.viewAVCInvoices = config.customerConfig.is_avc_invoices;
    });
  }
}
